const MMIR_DOMAIN_NAME = "mmir.agi.amazon.dev";
const CURRENT_URL = window.location.origin;

export const formatDate = (date) => {
  if (!date) return 'Unknown';
  let dateObj = new Date(date);
  if (dateObj.getFullYear() <= 1970) return 'Unknown';
  return dateObj.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

export const isLicensedImage = (sourceType) => {
  return ['getty', 'getty images', 'imdb', 'wikipedia'].includes(sourceType.toLowerCase());
}

export const getImageCreationDate = (sourceType, creationDate, lastUpdatedDate, acquiredAtDate, publishedAtDate) => {
  if (isLicensedImage(sourceType)) {
    return [creationDate, lastUpdatedDate, acquiredAtDate].find(d => typeof d !== 'undefined')
  } else {
    return [publishedAtDate, acquiredAtDate].find(d => typeof d !== 'undefined')
  }
}

export const openUrlInNewTab = (url) => {
  window.open(url, "_blank", "noreferrer");
};

export const getStage = () => {
  if (CURRENT_URL.includes(MMIR_DOMAIN_NAME)) {
    return "PROD";
  }
  if (CURRENT_URL.includes("beta")) {
    return "BETA";
  }
  if (CURRENT_URL.includes("gamma")) {
    return "GAMMA";
  }
  if (CURRENT_URL.includes("prod")) {
    return "PROD";
  }
  return "DEV";
}

export const getRegion = (stage) => {
  if (CURRENT_URL.includes(MMIR_DOMAIN_NAME)) {
    return "us-east-1";
  }
  if (stage === "DEV" || stage === "BETA") {
    return "us-west-2";
  }
  if (CURRENT_URL.includes("dub")) {
    return "eu-west-1";
  }

  if (CURRENT_URL.includes("iad")) {
    return "us-east-1";
  }

  if (CURRENT_URL.includes("pdx")) {
    return "us-west-2";
  }
  console.debug("Couldn't determine region. Defaulting to PDX");
  return "us-west-2"
}